<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button @click="(event) => handleButtonPress(event)">Create Visitor</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search" :searchIcon="true"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search"
              :clearFiltersCallback="() => clearFilters()" :filters="searchCategories"
              :searchCategoryUpdated="(category) => updateFilteredSearch(category, search)" :showSupportButtons="true"
              :updateFiltersCallback="(filters) => handleFilterUpdate(filters)"
              :currentFilters="computedSearchFilters"
              :filterConfiguration="filterConfiguration" 
              :hideReset="true"/>

          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="(data) => {
          handleModal(selectedItem, data);
        }" @options-changed="(data) => handleOptionsChange(data)" :search=search
          :processInputData="this.processInputData" :headers="headers" :pagination="pagination"
          :isLoading="isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
import VisitorModal from "../../modals/view/VisitorModal.vue";
import CreateFrequentVisitorModal from "../../modals/CreateFrequentVisitorModal.vue";
// import Insights from "../../layout/Insights.vue";

export default {
  name: "FrequentVisitors",
  props: ["subPage", "organizationData", "userData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      communityId: this.$props.organizationData.organization_id,
      selectedItem: Constants.FREQUENT_VISITORS,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      headerName: Constants.GATE,
      subHeader: "Here's a log of all keys sent for your Community.",
      page: this.subPage ? this.subPage : "",
      defaultFilters: {
        residentName: null,
        visitorName: null,
        subdivision: null,
        status: null,
        startTime: null,
        endTime: null
      },
      filters: {},
      tableData: [],
      search: "",
      headers: [
        { text: "Frequent Visitor Name", value: "visitor_name", align: "start", sortable: true, width: 200 },
        { text: "Resident Name", value: "resident_name", filterable: true, width: 175 },
        { text: "Unit", value: "unit_address", width: 175 },
        { text: "Resident Phone Number", value: "resident_phone", width: 175 },
        { text: "Start Time", value: "formatted_time", filterable: false, width: 180 },
        { text: "Expiration Time", value: "expiration_value", filterable: false, width: 180 },
        { text: "Visitor Status", value: "current_status", filterable: false, width: 175 },
        { text: "Visitor Relationship", value: "visitor_relationship", filterable: false, width: 175 },
        { text: "Times Visited", value: "times_visited", filterable: false, width: 180 },
        { text: "Frequent Visitor ID", value: "visitor_id", filterable: false, width: 180 }
      ],
      pagination: {},
      isLoading: false,
      defaultSearchFilters: {
        "visitorStatusCategory": "ACTIVE",
      },
      searchFilters: {},
      searchCategories: [
      ],
      filterConfiguration: [
        {
          sectionLabel: "Frequent Visitor Information",
          sectionFields: [
            {
              displayLabel: "Status",
              key: "visitorStatusCategory",
              configuration: {
                type: 'select',
                options: [
                  { label: "Active", value: "ACTIVE" },
                  { label: "Inactive", value: "INACTIVE" },
                ],
                placeholder: "Select",
                clearable: false
              }
            },
            // {
            //   displayLabel: "Status Type",
            //   key: "visitorStatus",
            //   configuration: {
            //     type: 'select',
            //     options: [
            //       { label: "Permanent", value: "PERMANENT" },
            //       { label: "Temporary", value: "TEMPORARY" },
            //       { label: "Deactivated", value: "DEACTIVATED" },
            //       { label: "In Review", value: "IN REVIEW" },

            //     ],
            //     placeholder: "Select"
            //   }
            // }
          ]
        },
      ],
    };
  },
  created() {
    console.log("Gate", this)
    this.changeView(this.selectedItem);
    EventBus.$on("keys", this.changeView);
    EventBus.$on("incidents", this.changeView);
    EventBus.$on("refreshData", () => this.performSearch(this.search))

    var date = new Date();
    this.defaultEndDate = date.toISOString().split("T")[0];
    var startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06";
    this.filters = this.defaultFilters

    this.performSearch("").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData)
      this.search = ""
    });
  },
  watch: {
    search(newVal) {
      this.filters = this.defaultFilters
      if (newVal == "") {
        this.performSearch()
      }
    },
    organizationData: function (newVal) {
      this.communityId = newVal.organization_id
      this.performSearch()
    }
  },
  computed: {
    computedSearchFilters() {
      if(Object.keys(this.searchFilters) < 1) {
        return this.defaultSearchFilters
      }
      return this.searchFilters
    }
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal");
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    changeView(name) {
      console.log("Changing View from ", this.selectedItem, " to ", name);
    },
    performSearch(data, limit, page) {
      if (this.communityId == undefined || this.isLoading) {
        return
      }
      this.isLoading = true
      this.search = data
      const filters = this.computedSearchFilters
      console.log("Computed Search Filters for Search", filters)
      return new CTSRepository(this.$props.organizationData).fetchFrequentVisitors(data, filters, limit, page)
        .then((data) => {
          console.log("Search Data", data);
          this.tableData = data.data
          this.pagination.totalItems = data.pagination.totalItems
          this.isLoading = false
        })
        .catch((err) => {
          console.log("Error fetching frequent visitors", err)
          this.isLoading = false
        })
    },
    async handleOptionsChange(data) {
      console.log("Option Change Data", data)
      await this.performSearch(this.search, data.itemsPerPage, data.page)
      this.pagination = { ...this.pagination, ...data }
    },
    updateFiltersForSearchBasedOnCard(card) {
      this.filters = card.filters ?? this.defaultFilters
      this.performSearch(this.search).then(() => {
      })
    },
    handleButtonPress() {
      this.$modal.show(CreateFrequentVisitorModal, {
        organizationData: this.$props.organizationData,
        userData: this.$props.userData,
      }, {
        transition: "fade",
        top: "0",
        width: "700",
        height: "auto",
        draggable: "true",
        adaptive: true,
        styles: "border-radius: 4px;"
      })
    },
    openGateModal() {
      this.$modal.show(Constants.GATE_MODAL);
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration, data) {
      this.$modal.show(VisitorModal, {
        selectedVisitorData: data,
        organizationData: this.$props.organizationData,
        userData: this.$props.userData,
      }, {
        transition: "fade",
        top: "0",
        width: "650",
        height: "auto",
        draggable: "true",
        adaptive: false,
        styles: "border-radius: 22px;"
      })
    },
    processInputData(inputData) {
      return inputData.map(item => {
        //console.log("Mapping over item", item)
        return {
          ...item,
          visitor_name: `${item.visitor_first_name} ${item.visitor_last_name}`,
          resident_name: `${item.user_data.first_name} ${item.user_data.last_name}`,
          resident_phone: `${item.user_data.phone}`,
          unit_address: `${item.user_data.unit_data.unit_address}`,
          formatted_time: `${new Date(item.time_created).toLocaleDateString()}`,
          current_status_mapped: `${item.current_status == "BLOCKED" ? "Active" : "blocked"}`,
          expiration_value: `${item.expiration != null ? new Date(item.expiration).toLocaleDateString() : "N/A"}`
        }
      })
    },
    updateFilteredSearch(category, data) {
      console.log(`Updating Filtered Search ${category}, ${data}`)
      if (category == null || category.trim() == "") {
        delete this.searchFilters[this.selectedSearchCategory]
        return;
      }
      //if (data == null || data == undefined || data.trim() == "") {
      delete this.searchFilters[this.selectedSearchCategory]
      delete this.searchFilters[category]
      //    return;
      //}
      console.log(`Updating Filtered Search ${category}, ${data}`)
      this.selectedSearchCategory = category
      this.searchFilters[category] = data
    },
    updateDateRange(dateRange) {
      this.searchFilters['active_time_start'] = dateRange[0]
      this.searchFilters['active_time_end'] = dateRange[1]
    },
    clearFilters() {
      this.searchFilters = {}
      this.selectedSearchCategory = ""
      this.performSearch("")
    },
    handleFilterUpdate(filters) {
      console.log("Current Search Filters", this.searchFilters)
      console.log("New Search Filters", filters)
      this.searchFilters = filters
      this.performSearch(this.search)
    },
  }
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.filterIcon {
  margin-right: 16px;
}

input[type="text"]:focus {
  background-color: lightblue;
}

input[type="date"]:focus {
  outline: none;
  border: 0;
  appearance: none;
  border-width: 0px;
  border: none;
}

.pageHeader button {
  background-color: #1890FFCC !important;
}
</style>